import OrderMethod from './order-method-controller'

export default OrderMethod
